import { useQuery } from "@tanstack/react-query"
import type { Prisma } from "@tfg/db"

import {
  OrganizationPublicConfig,
  PublicDisplaySettings,
} from "@tfg/types/endpoints/agec"
import { PublicResponses } from "@tfg/types/endpoints/public"

import { httpClient } from "~/backend/axios"

export const usePublicCompanyQuery = (companySlug: string) => {
  return useQuery<OrganizationPublicConfig>(
    ["public", "company", companySlug],
    async () => {
      const response = await httpClient.get(`public/${companySlug}`)
      return response.data
    }
  )
}

export const usePublicDisplaySettingsQuery = (slug: string) => {
  return useQuery<PublicDisplaySettings>(
    ["public", "display-settings", slug],
    async () => {
      const response = await httpClient.get(`public/${slug}`)
      return response.data
    }
  )
}

export const usePublicProductsQuery = (
  companySlug: string | undefined,
  searchParams: URLSearchParams,
  filters?: Prisma.JsonValue
) =>
  useQuery<PublicResponses.GetProductsCard>({
    queryKey: ["public", "products", companySlug, ...searchParams],
    enabled: !!companySlug,
    queryFn: async () => {
      const params = Object.fromEntries(searchParams)
      Object.assign(params, { filters })
      const response = await httpClient.get(`public/${companySlug}/products`, {
        params,
      })
      return response.data
    },
  })
